import { ReportingPeriodsService } from '../../api/services';

export function getAllReportingPeriods() {
  return ReportingPeriodsService.find({
    query: { $limit: 500, $sort: { createdAt: -1 } },
  });
}
